import React, { useRef } from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const DeliverNationwide = () => {
    
        const sliderRef = useRef(null);
        const settings = {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        };
    return (
        <>

            <SeoMeta
                title="Exotic Car Nationwide Delivery - Mark Motors Boerne & Austin TX"
                description="Mark Motors are experts in delivering exotic cars across the country. If you&#039;re looking for a fast safe nationwide delivery service contact us today"
                keywords="Mark Motors Delivers Nationwide"
                ogTitle="Exotic Car Nationwide Delivery - Mark Motors Boerne & Austin TX"
                ogDescription="Mark Motors are experts in delivering exotic cars across the country. If you&#039;re looking for a fast safe nationwide delivery service contact us today"
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">

                        <h1>We Deliver Nationwide</h1>

                        <Slider ref={sliderRef} {...settings} className='common-slider common-dots'>
                            <img src={getImages('new/customer-slideshow-blue-ferarri.jpg')} alt='Blue Ferarri' />
                            <img src={getImages('new/customer-slideshow-double-porsche.jpg')} alt='Two Porsche' />
                            <img src={getImages('new/customer-slideshow-ford_gt.jpg')} alt='Ford GT' />
                            <img src={getImages('new/customer-slideshow-black_ferrari.jpg')} alt='Black Ferarri' />
                            <img src={getImages('new/customer-slideshow-couple_house.jpg')} alt='Bentley Couple House' />
                            <img src={getImages('new/customer-slideshow-twocars_house.jpg')} alt='Two Cars House' />
                            <img src={getImages('new/customer-slideshow-green-bentley.jpg')} alt='Green Porsche and Bentley' />
                            <img src={getImages('new/customer-slideshow-mask.jpg')} alt='Mask' />
                            <img src={getImages('new/customer-slideshow-two_red.jpg')} alt='Two Red' />
                            <img src={getImages('new/customer-slideshow-blue-urus.jpg')} alt='Blue Urus' />
                            <img src={getImages('new/customer-slideshow-black-bentley-purse.jpg')} alt='Black Bentley Purse' />
                            <img src={getImages('new/customer-slideshow-orange-mclaren.jpg')} alt='Orange McLaren' />
                            <img src={getImages('new/customer-slideshow-grey-gwagon.jpg')} alt='Grey G63' />
                        </Slider>

                    </div>
                </div>
            </section>
        </>
    )
}

export default DeliverNationwide